module.exports = __webpack_public_path__ + "d7731a667e93ed3e6ff77f615f671596.svg";